import React, { Fragment } from 'react';
import { length, includes, append, without } from 'ramda';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Button } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import useScreen from 'hooks/useScreen';
import Loader from 'sharedComponents/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import Icon from 'sharedComponents/Icon';

import LoanOfficerCard from './components/LoanOfficerCard';
import useStyles from './useStyles';

const WaitlistLoanOfficersList = props => {
  const {
    loanOfficers,
    isLoading,
    meta,
    onLoadMore,
    onApproveLoanOfficer,
    onBatchApproveLoanofficers,
    isApproving,
    isBatchApproving,
    selectedLoanOfficersIds,
    setSelectedLoanOfficersIds,
  } = props;
  const { isDesktop } = useScreen();
  const classes = useStyles();
  const { t } = useTranslation();

  const isSelectedLoanOfficersEmpty = isBlank(selectedLoanOfficersIds);

  if (isLoading) {
    return (
      <div className={classes.loaderBox}>
        <Loader />
      </div>
    );
  }

  if (isBlank(loanOfficers)) {
    return (
      <div className={classes.container}>
        <Typography className={classes.emptyLabel} variant="subtitle1">
          {t('components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.noLoanOfficers')}
        </Typography>
      </div>
    );
  }

  const { totalPages, currentPage } = meta;
  const hasMore = currentPage < totalPages;
  const nextPage = currentPage + 1;

  const handleLoadMore = () => {
    onLoadMore({ page: nextPage });
  };

  const handleSelect = e => {
    const { checked, value } = e.target;
    const normalizedValue = Number(value);
    if (checked && !includes(normalizedValue, selectedLoanOfficersIds)) {
      setSelectedLoanOfficersIds(append(normalizedValue, selectedLoanOfficersIds));
    } else {
      setSelectedLoanOfficersIds(without([normalizedValue], selectedLoanOfficersIds));
    }
  };

  const handleBatchApprove = () => {
    onBatchApproveLoanofficers(selectedLoanOfficersIds);
  };

  return (
    <Fragment>
      <div className={classes.topBar}>
        <div className={classes.rows}>
          <Typography variant="subtitle1" color="secondary">
            {t('components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.selectedRows')}
          </Typography>
          <Typography variant="h3" className={classes.rowsCount}>
            {length(selectedLoanOfficersIds)}
          </Typography>
        </div>
        <Button
          startIcon={<Icon name="check" className={classes.addIcon} />}
          disabled={isSelectedLoanOfficersEmpty}
          onClick={handleBatchApprove}
          className={classes.approveButton}
        >
          {t('components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.approveAll')}
        </Button>
      </div>
      <div className={classes.container} id="scrollableDiv" key="scrollableDiv">
        <InfiniteScroll
          dataLength={length(loanOfficers)}
          next={handleLoadMore}
          hasMore={hasMore}
          loader={
            <div>
              {[1, 2, 3].map(key => (
                <div key={key} className={classes.skeletonBox}>
                  <Skeleton variant="circle" animation="wave" width={40} height={40} />
                  <Skeleton variant="rect" animation="wave" className={classes.skeletonText} />
                </div>
              ))}
            </div>
          }
          scrollableTarget={isDesktop ? 'scrollableDiv' : 'scrollableMainContainer'}
        >
          {loanOfficers.map(loanOfficer => {
            const isSelected = includes(loanOfficer.id, selectedLoanOfficersIds);
            return (
              <LoanOfficerCard
                key={loanOfficer.id}
                loanOfficer={loanOfficer}
                onSelect={handleSelect}
                isSelected={isSelected}
                onApprove={onApproveLoanOfficer}
                isApproving={isApproving || isBatchApproving}
              />
            );
          })}
        </InfiniteScroll>
      </div>
    </Fragment>
  );
};

WaitlistLoanOfficersList.propTypes = {
  loanOfficers: PropTypes.arrayOf(PropTypes.shape()),
  isLoading: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  meta: PropTypes.shape(),
  onApproveLoanOfficer: PropTypes.func.isRequired,
  onBatchApproveLoanofficers: PropTypes.func.isRequired,
  isApproving: PropTypes.bool.isRequired,
  isBatchApproving: PropTypes.bool.isRequired,
  selectedLoanOfficersIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  setSelectedLoanOfficersIds: PropTypes.func.isRequired,
};

WaitlistLoanOfficersList.defaultProps = {
  loanOfficers: [],
  meta: {},
};

export default WaitlistLoanOfficersList;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/WaitlistLoanOfficersList/WaitlistLoanOfficersList.js